import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.scss';

export const Label = ({ text, wrapperClassName, type, indicator, indicatorClassName, onClick }) => (
  <div
    className={classnames('fr-label', type && `fr-label--${type}`, wrapperClassName)}
    onClick={() => onClick && onClick()}
  >
    {indicator && (
      <span className={classnames('fr-label__indicator', `fr-label__indicator--${type}`, indicatorClassName)} />
    )}

    {text}
  </div>
);

Label.propTypes = {
  indicator: PropTypes.bool,
  indicatorClassName: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['blue', 'invisible', 'white-blue', 'button-transparent', 'button-grey', false]),
  wrapperClassName: PropTypes.string,
};
